import React from "react";
import "./index.css";
import Page1 from "./pages/Page1.jsx";
import Page3 from "./pages/Page3.jsx";
import Page4 from "./pages/Page4.jsx";
import Page5 from "./pages/Page5.jsx";
import Page6 from "./pages/Page6.jsx";
import HireMe from "./pages/HireMe.jsx";
import Header from "./components/Header.jsx";

export default function App() {
//   useEffect(() => {
//   const handleWheel = (e) => {
//     // reduce scroll delta to make scrolling slower
//     window.scrollBy(0, e.deltaY * 0.85); // 0.5 = slower, 1 = normal
//     e.preventDefault();
//   };

//   window.addEventListener("wheel", handleWheel, { passive: false });

//   return () => {
//     window.removeEventListener("wheel", handleWheel);
//   };
// }, []);
  return (
    <>
      <div id="main">
        <Header />

        <div id="Page1">
          <Page1 />
        </div>

        {/* <div id="Page2">
          <Page2A />
          <Page2B />
        </div> */}

        <div id="Page4">
          <Page4 />
        </div>

         <div id="Page6" className="mb-0">
          <Page6 />
        </div>

        <div id="Page3" >
          <Page3 />
        </div>

        <div id="Page5">
          <Page5 />
        </div>

        <div id="HireMe">
          <HireMe />
        </div>
      </div>
    </>
  );
}
